import React from 'react';
import { OccurrenceDetail } from '../../components/occurrence/OccurrenceDetail';
import { EventParamList } from '../../typings/Params';
import { RouteProp, useRoute } from '@react-navigation/native';


interface EventsOccurrenceDetailParams {
    navigation: Navigation;
}

export default function EventsOccurrenceDetail({ navigation }: EventsOccurrenceDetailParams) {
    const route = useRoute<RouteProp<EventParamList, 'EventsOccurrenceDetail'>>();
    return (
        <OccurrenceDetail navigation={navigation} occurrenceId={route.params.occurrenceId} page={'events'} />
    );
}
